import { put, takeLatest } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { SERIALIZE_CONTENT } from 'catalog/actions/contents';
import {
  SERIALIZE_PAGE,
  CANCEL_PENDING,
  UPDATE_PAGE,
} from 'catalog/actions/pages';

function* showPending() {
  yield put(
    toastrActions.add({
      type: 'light',
      title: 'Modification en cours',
      message: `Des modifications sont en cours sur cette page. N'oubliez pas d'enregistrer`,
      options: {
        timeOut: 0,
        showCloseButton: false,
        icon: 'warning',
        status: 'warning',
      },
    })
  );
}

function* hidePending() {
  yield put(toastrActions.removeByType('light'));
}

export default function* root() {
  yield [
    takeLatest([SERIALIZE_CONTENT, SERIALIZE_PAGE], showPending),
    takeLatest([CANCEL_PENDING, UPDATE_PAGE], hidePending),
  ];
}



// WEBPACK FOOTER //
// ./src/modules/catalog/sagas/pending.js